import React from 'react';
import { IconButton, Typography, Box } from '@mui/material';
import favoriteIcon from '../../assets/favorite_primary.svg';
import favoriteOutlinedIcon from '../../assets/favorite_outlined_b3.svg';
import theme from '../../theme';

const FavoriteButton = ({ isLiked, onToggle, likeCount }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <IconButton
        disableRipple
        onClick={onToggle}
        aria-label="toggle favorite"
        sx={{
          width: 20,
          height: 20,
          padding: 0,
        }}
      >
        <Box
          component="img"
          src={isLiked ? favoriteIcon : favoriteOutlinedIcon}
          alt="favorite icon"
          sx={{ width: '100%', height: '100%' }}
        />
      </IconButton>
      {likeCount > 0 && (
        <Typography fontSize={14} color={theme.palette.black[4]}>
          {likeCount}
        </Typography>
      )}
    </Box>
  );
};

export default FavoriteButton;
